var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 85 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M60.313 15.949V32.68c0 3.118-2.551 5.669-5.669 5.669H30.356c-3.118 0-5.669-2.551-5.669-5.669V15.949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M60.273 15.768L46.628 23.86c-2.533 1.915-5.72 1.97-8.381 0l-13.515-7.907M31.186 11.226l-6.429 4.658M60.273 15.768l-5.903-4.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M31.181 19.487V8.149a4.498 4.498 0 014.498-4.498h13.602a4.498 4.498 0 014.498 4.498v11.338"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_green",
    d: "M48.514 19.569l-3.256 1.623a6.23 6.23 0 01-5.557 0l-3.256-1.623a3.251 3.251 0 01-1.822-2.902v-6.528c0-1.8 1.497-3.26 3.344-3.26h9.025c1.847 0 3.344 1.459 3.344 3.26v6.528a3.251 3.251 0 01-1.822 2.902z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketDone);
export default __webpack_public_path__ + "static/media/ticket_done.eaba98f4daa654058162f69b8a3d4526.svg";
export { ForwardRef as ReactComponent };